import React, { Component } from "react";
import "./ventas.css";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import Navbar from "../../componentes/navbar/navbar";
import { cancelarFactura, descargarFacturapdf, descargarFacturaxml, editarVentasAfiliacion, getDetallesVentas, getListaAfiliacion, getListaNacionalidad, getListSat, getVntas, guardarSolicitud, importarProductosExcel, importarVentasExcel, importSantanderExcel } from "../../service/api";
import ImportVentasModal from "../../componentes/modal/ImportVentasModal";
import { toast } from "react-toastify";

import { FaSyncAlt } from "react-icons/fa";
import { DatePicker } from "react-rainbow-components";
import VentaDetalleModal from "../../componentes/modal/Ventas/VentaDetalleModal";
import VentaEditarModal from "../../componentes/modal/Ventas/VentaEditarModal";


export default class VentasPage extends Component {


    state = {
        loading: false,
        fecha: localStorage.getItem("ventas_fecha") || this.toISODate(new Date()),
        ventas: [],
        sortKey: "hora",
        sortDir: "desc",
        vermodalImpor: false,
        banderaSubir: "normal",
        selectedRowId: null,
        editingAfRowId: null,
        editingAfValue: "",
        q: "",
        array_afiliados: [],
        editVentaData: {},
        showEditVenta: false,
        afQueryByRow: {},
        afOpenRowId: null,
        showDetalleModal: false,
        detalleVentaLoading: false,
        detalleVentaData: null,
        array_nacionalidad: [],


        array_catalogo_sat: {},

    };


    async componentDidMount() {
        this.setState({ loading: true });

        const datos = localStorage.getItem("datosm");
        if (!datos || datos === "") {
            window.location.href = "/";
            return;
        }

        try {
            await this.cargarDatos();
            await this.fetchVentas(this.state.fecha);
        } finally {
            document.addEventListener("mousedown", this.handleOutsideAf);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleOutsideAf);
    }

    handleDescargarFacturaXml = async (venta) => {
        try {
            //console.log("Folio para descargar XML:", venta);
            const folio = venta?.folio;

            if (!folio) {
                toast.info("No se encontró el folio para descargar el XML.");
                return;
            }

            const resp = await descargarFacturaxml(folio);

            if (!resp || Number(resp.code) !== 0 || !resp.data) {
                toast.info(resp?.message || "No se pudo descargar el XML.");
                return;
            }

            const xmlContent = String(resp.data || "").trim();
            if (!xmlContent) {
                toast.info("El XML llegó vacío.");
                return;
            }

            const blob = new Blob([xmlContent], { type: "application/xml;charset=utf-8" });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `factura_${folio}.xml`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Ocurrió un error al descargar el XML.");
        }
    };

    handleDescargarFacturaPdf = async (venta) => {
        try {
            const folio = venta.folio
            //console.log("Folio para descargar PDF:", venta);

            if (!folio) {
                toast.info("No se encontró el folio para descargar el PDF.");
                return;
            }

            const resp = await descargarFacturapdf(folio);

            if (!resp || Number(resp.code) !== 0 || !resp.data) {
                toast.info(resp?.message || "No se pudo descargar el PDF.");
                return;
            }

            // Caso 1: viene base64 puro
            // Caso 2: viene data:application/pdf;base64,...
            let base64 = String(resp.data || "").trim();
            if (!base64) {
                toast.info("El PDF llegó vacío.");
                return;
            }

            base64 = base64.replace(/^data:application\/pdf;base64,/, "");

            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `factura_${folio}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error("Ocurrió un error al descargar el PDF.");
        }
    };

    cargarDatos = async () => {
        try {
            const respSat = await getListSat();
            if (respSat.code === 0) {
                this.setState({ array_catalogo_sat: respSat.data || {} });
            } else {
                this.setState({ array_catalogo_sat: {} });
            }

            const respw = await getListaNacionalidad();
            if (respw && respw.code === 0) {
                this.setState({ array_nacionalidad: respw.data || [] });
            } else {
                this.setState({ array_nacionalidad: [] });
            }

            const resp = await getListaAfiliacion();
            if (resp.code === 0) {
                let temp = resp.data || [];

                for (let i = 0; i < temp.length; i++) {
                    if (temp[i].afiliacion != null && temp[i].banco != null) {
                        temp[i].busqueda = temp[i].afiliacion + " - " + temp[i].banco;
                    } else {
                        temp[i].busqueda = "";
                    }
                }

                temp.unshift({
                    idafiliacion: -1,
                    afiliacion: "Agregar Nuevo",
                    banco: "",
                    busqueda: "Agregar Nuevo",
                    idmoneda: null,
                    compania: "",
                    cuenta: "",
                    comentarios: "",
                    codigo: "",
                    moneda: ""
                });

                this.setState({ array_afiliados: temp });
            } else {
                this.setState({ array_afiliados: [] });
            }
        } catch (e) {
            this.setState({
                array_catalogo_sat: {},
                array_nacionalidad: [],
                array_afiliados: [],
            });
        }
    };


    handleOutsideAf = (e) => {
        // si el click no está dentro de un contenedor de autocomplete, cierra
        if (!e.target.closest(".v-afAuto")) {
            this.setState({ afOpenRowId: null });
        }
    };


    toISODate(dateObj) {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    currencyMX = (n) => {
        const val = Number(n || 0);
        return val.toLocaleString("es-MX", { style: "currency", currency: "MXN" });
    };


    getEstatusClass = (id) => {
        const map = {
            1: "none",
            4: "green",
            5: "warn",
            3: "blue",
        };
        return map[Number(id)] || "none";
    };

    fetchVentas = async (fechaISO, options = {}) => {
        const { keepLoading = false } = options;

        if (!keepLoading) {
            this.setState({ loading: true });
        }

        try {
            const resp = await getVntas({ fecha: fechaISO });

            if (resp.code === 0) {
                const raw = resp?.data || [];
                const ventas = raw;
            
                this.setState({
                    ventas,
                    page: 1,
                    selectedRowId: null,
                    ...(keepLoading ? {} : { loading: false }),
                });
            
                return ventas;
            }

            if (resp.code === 2003) {
                if (!keepLoading) {
                    this.setState({ loading: false });
                }
                this.logoutByTokenExpired();
                return null;
            }

            toast.info(resp.message || "No fue posible obtener las ventas");

            this.setState({
                ventas: [],
                page: 1,
                selectedRowId: null,
                ...(keepLoading ? {} : { loading: false }),
            });

            return null;
        } catch (e) {
            this.setState({
                ventas: [],
                page: 1,
                selectedRowId: null,
                ...(keepLoading ? {} : { loading: false }),
            });
            return null;
        }
    };

    onChangeFecha = (dateObj) => {
        if (!dateObj) return;

        const fechaISO = this.toISODate(dateObj);

        localStorage.setItem("ventas_fecha", fechaISO);

        this.setState({ fecha: fechaISO }, () => this.fetchVentas(fechaISO));
    };

    onImportar = (bandera) => {
        this.setState({ banderaSubir: bandera, vermodalImpor: true });
    };

    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric =
            !Number.isNaN(na) &&
            !Number.isNaN(nb) &&
            String(a).trim() !== "" &&
            String(b).trim() !== "";

        if (bothNumeric) return na - nb;

        return String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });
    };

    getSortValue = (v, key) => {
        switch (key) {
            case "idticket":
            case "ticket":
                return v.idticket;
    
            case "locacion":
                return v.locacion;
    
            case "metodo_pago":
            case "metodoPago":
                return `${v.metodo_pago || ""} ${v.ultimos_digitos || ""}`;
    
            case "subtotal":
                return Number(v.subtotal || 0);
    
            case "iva":
                return Number(v.iva || 0);
    
            case "total":
                return Number(v.total || 0);
    
            case "total_cobrado":
                return Number(v.total_cobrado || 0);
    
            case "propina":
                return Number(v.propina || 0);
    
            case "fecha":
                return v.fecha;
    
            case "productos":
                return Number(v.productos || 0);
    
            case "estatus":
                return v.estatus;
    
            case "hora":
                return v.hora;
    
            // 🔥 NUEVOS CAMPOS
    
            case "afiliacion":
                return v.afiliacion;
    
            case "banco":
                return `${v.banco || ""} ${v.codigo || ""}`;
    
            case "campana": // (tu TH usa campana pero el campo es compania)
                return v.compania;
    
            case "cuenta":
                return v.cuenta;
    
            case "tc":
                return Number(v.tc || 0);
    
            case "total_mxn":
                return Number(v.totalmxn || 0);
    
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };

    getSortedItems = () => {
        const { ventas, sortKey, sortDir } = this.state;

        return [...(ventas || [])].sort((va, vb) => {
            const a = this.getSortValue(va, sortKey);
            const b = this.getSortValue(vb, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });
    };

    importVentas = async (file) => {
        try {
          this.setState({ loading: true, vermodalImpor: false });
      
          const r = await importarVentasExcel(file);
      
          if (r.code === 0) {
            toast.success(r.message || "Ventas importadas.");
            this.setState({ vermodalImpor: false }, () => {
              this.fetchVentas(this.state.fecha);
            });
          } else {
            toast.info(r.message || "No fue posible importar las ventas.");
          }
        } catch (e) {
          toast.error("Ocurrió un error al importar las ventas.");
        } finally {
          this.setState({ loading: false });
        }
      };


    importVentasSantnder = async (file) => {
        const r = await importSantanderExcel(file);

        if (r.code === 0) {
            toast.success("Ventas importadas correctamente.");
            this.fetchVentas(this.state.fecha);
            this.setState({ vermodalImpor: false });
        } else {
            toast.info(`${r.code} - ${r.message}`);
        }
    };

    isFacturaFacturada = (venta) => {
        const estatus = String(venta?.estatus || "").trim().toLowerCase();
        return estatus === "facturado";
    };


    onSelectRow = (rowId) => {
        this.setState((prev) => ({
            selectedRowId: prev.selectedRowId === rowId ? null : rowId,
        }));
    };

    parseISOToDate = (iso) => {
        if (!iso) return new Date();
        const [y, m, d] = iso.split("-").map(Number);
        return new Date(y, (m || 1) - 1, d || 1);
    };

    setHoy = () => {
        const hoyISO = this.toISODate(new Date());
        localStorage.setItem("ventas_fecha", hoyISO);
        this.setState({ fecha: hoyISO }, () => this.fetchVentas(hoyISO));
    };
    /// --- 
    afLabel = (a) => `${a?.afiliacion ?? ""} - ${a?.banco ?? ""}`.trim();

    getAfSuggestions = (query) => {
        const q = String(query || "").toLowerCase().trim();
        const { array_afiliados } = this.state;

        if (!q) return (array_afiliados || []).slice(0, 10);

        return (array_afiliados || [])
            .filter((a) => {
                const text = `${a.busqueda} ${a.afiliacion} ${a.banco} ${a.compania}`.toLowerCase();
                return text.includes(q);
            })
            .slice(0, 10);
    };

    onAfChange = (rowId, value) => {
        this.setState((prev) => ({
            afQueryByRow: { ...(prev.afQueryByRow || {}), [rowId]: value },
            afOpenRowId: rowId,
        }));
    };

    onAfBlur = (venta) => {
        const rowId = venta.idticketpago;

        setTimeout(() => {
            this.setState((prev) => {
                const current = (prev.afQueryByRow?.[rowId] ?? "").trim();

                const nextState = { afOpenRowId: prev.afOpenRowId === rowId ? null : prev.afOpenRowId };
                if (current === "") {
                    const next = { ...(prev.afQueryByRow || {}) };
                    delete next[rowId];
                    return { ...nextState, afQueryByRow: next };
                }

                return nextState;
            });
        }, 150);
    };


    closeAfDropdown = () => {
        this.setState({ afOpenRowId: null });
    };

    getDefaultAfText = (v) => {
        const af = (v?.afiliacion || "").trim();
        const b = (v?.banco || "").trim();
        const txt = `${af}${af && b ? " - " : ""}${b}`.trim();
        return txt || "";
    };

    onAfSelect = async (venta, a) => {
        if (a.idafiliacion === -1) {
            window.location.href = "/afiliaciones";
            return;
        }

        try {
            this.setState({ loading: true, afOpenRowId: null });

            const payload = { afiliacion: a.afiliacion };
            const resp = await editarVentasAfiliacion(venta.idticketpago, payload);

            if (resp.code === 0 && resp.data) {
                const api = resp.data;

                this.setState((prev) => ({
                    ventas: (prev.ventas || []).map((x) =>
                        x.idticketpago === venta.idticketpago
                            ? {
                                ...x,

                                // ids
                                idticketpago: api.idticketpago ?? x.idticketpago,
                                idticket: api.idticket ?? x.idticket,

                                // datos principales
                                locacion: api.locacion ?? x.locacion,
                                afiliacion: api.afiliacion ?? x.afiliacion,
                                idafiliacion: api.idafiliacion ?? x.idafiliacion,
                                banco: api.banco ?? x.banco,
                                compania: api.compania ?? x.compania,
                                cuenta: api.cuenta ?? x.cuenta,
                                codigo: api.codigo ?? x.codigo,

                                // método / pago
                                metodoPago: api.metodo_pago ?? x.metodoPago,
                                metodo_pago: api.metodo_pago ?? x.metodo_pago,
                                ultimosDigitos: api.ultimos_digitos ?? x.ultimosDigitos,
                                ultimos_digitos: api.ultimos_digitos ?? x.ultimos_digitos,

                                // cantidades
                                total: api.total ?? x.total,
                                propina: api.propina ?? x.propina,
                                tc: api.tc ?? x.tc,
                                totalmxn: api.totalmxn ?? x.totalMXN,
                                total_cobrado: api.total_cobrado ?? x.total_cobrado,
                                moneda_cobro: api.moneda_cobro ?? x.moneda_cobro,

                                // hora / estatus
                                hora: api.hora ?? x.hora,
                                idestatus: api.idestatus ?? x.idestatus,
                                estatus: api.estatus ?? x.estatus,
                                estatusTxt: api.estatus ?? x.estatusTxt,

                                // productos
                                productos: api.productos ?? x.productos,

                                // detalle para que siga pintando subtotal / iva
                                detalles: {
                                    ...(x.detalles || {}),
                                    subtotal: api.subtotal ?? x.detalles?.subtotal,
                                    iva: api.iva ?? x.detalles?.iva,
                                },

                                // por si en otros lados usas estos campos directos
                                subtotal: api.subtotal ?? x.subtotal,
                                iva: api.iva ?? x.iva,
                            }
                            : x
                    ),
                    afQueryByRow: {
                        ...(prev.afQueryByRow || {}),
                        [venta.idticketpago]: `${api.afiliacion || ""} - ${api.banco || ""}`,
                    },
                    loading: false,
                }));

                toast.success(resp.message || "Afiliación actualizada.");
            } else {
                toast.info(resp.message || "No se pudo actualizar la afiliación.");
                this.setState({ loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
            toast.error("Error al actualizar afiliación.");
        }
    };
    // ---

    startEditAfiliacion = (venta) => {
        this.setState({
            editingAfRowId: venta.idticketpago,
            editingAfValue: venta.afiliacion ?? "",
        });
    };

    cancelEditAfiliacion = () => {
        this.setState({ editingAfRowId: null, editingAfValue: "" });
    };

    saveAfiliacion = async (venta) => {
        this.setState({ loading: true })
        var json = { afiliacion: this.state.editingAfValue }
        //// consolelog(venta, json)
        var resp = await editarVentasAfiliacion(venta.idticketpago, json)

        if (resp.code === 0) {
            toast.success("Afiliación actualizada.");
            this.setState((prev) => ({
                ventas: (prev.ventas || []).map((x) =>
                    x.idticketpago === venta.idticketpago
                        ? { ...x, afiliacion: prev.editingAfValue }
                        : x
                ),
                editingAfRowId: null,
                editingAfValue: "",
            }));
            this.setState({ loading: false })

        }
        else {
            toast.info(resp.message);
            this.setState({ loading: false })

        }


    };
    importProductos = async (file) => {

        const r = await importarProductosExcel(file);

        if (r?.code === 2003) {
            toast.info("Sesión expirada.");
            window.location.href = "/";
            return;
        }

        if (r?.code !== 0) {
            toast.info(`${r?.code} - ${r?.message || "No se pudo importar productos."}`);
            return;
        }

        toast.success(r?.message || "Productos importados.");
    };


    openEdit = async (venta) => {
        //console.log(JSON.stringify(venta));
        try {
            this.setState({
                editVentaData: venta,
                showEditVenta: true,
            });

        } catch (e) { }
    }

    handleVentaSavedLocal = async (updatedRow) => {
        try {
            const idticketpago = Number(updatedRow?.idticketpago || 0);
            if (!idticketpago) return;
    
            const ventas = await this.fetchVentas(this.state.fecha);
    
            const ventaActualizada = (ventas || []).find(
                (v) => Number(v.idticketpago) === idticketpago
            );
    
            this.setState({
                editVentaData: ventaActualizada || updatedRow || {},
            });
        } catch (e) {
           // console.log("Error al refrescar venta editada:", e);
        }
    };
    
    closeEdit = (result) => {
        const updatedRow = result?.updatedRow || null;
    
        this.setState({
            editVentaData: updatedRow || {},
            showEditVenta: false,
        });
    };

    verDetalles = async (venta) => {
        //console.log(JSON.stringify(venta));
        try {
            this.setState({
                loading: true,
                detalleVentaLoading: true,
                showDetalleModal: true,
            });

            const resp = await getDetallesVentas(venta.idticketpago);

            if (resp.code === 2003) {
                toast.error("Tu sesión ha expirado");
                this.logoutByTokenExpired();
                return;
            }

            if (resp.code !== 0) {
                this.setState({
                    loading: false,
                    detalleVentaLoading: false,
                    detalleVentaData: null,
                });
                toast.error(resp.message || "No fue posible obtener los detalles");
                return;
            }

            const detalle = Array.isArray(resp.data) && resp.data.length > 0
                ? resp.data[0]
                : null;

            this.setState({
                loading: false,
                detalleVentaLoading: false,
                detalleVentaData: detalle,
                showDetalleModal: true,
            });
        } catch (e) {
            this.setState({
                loading: false,
                detalleVentaLoading: false,
                detalleVentaData: null,
            });
            toast.error("Ocurrió un error al consultar el detalle");
        }
    };
    closeDetalleModal = () => {
        this.setState({
            showDetalleModal: false,
            detalleVentaLoading: false,
            detalleVentaData: null
        });
    };

    logoutByTokenExpired = () => {
        localStorage.removeItem("datosm");
        localStorage.removeItem("ventas_fecha");
        window.location.href = "/";
    };

    refreshVentas = async () => {
        try {
            this.setState({ loading: true });
            await this.fetchVentas(this.state.fecha);
        } catch (e) {
            //     toast.error("No fue posible refrescar");
        }
    };

    refreshDetalleModal = async (idticketpago) => {
        const resp = await getDetallesVentas(idticketpago);

        if (resp.code === 2003) {
            toast.error("Tu sesión ha expirado");
            this.logoutByTokenExpired();
            return null;
        }

        if (resp.code !== 0) {
            toast.error(resp.message || "No fue posible refrescar el detalle");
            return null;
        }

        const detalle = Array.isArray(resp.data) && resp.data.length > 0
            ? resp.data[0]
            : null;

        this.setState({
            detalleVentaData: detalle,
        });

        return detalle;
    };

    refreshVentasAndDetalle = async () => {
        try {
            const fecha = this.state.fecha;

            const idticketpago =
                this.state.detalleVentaData?.pagos?.[0]?.idticketpago ||
                this.state.detalleVentaData?.pago?.idticketpago;

            let detalle = null;
            let ventas = null;

            if (idticketpago) {
                [detalle, ventas] = await Promise.all([
                    this.refreshDetalleModal(idticketpago),
                    this.fetchVentas(fecha, { keepLoading: true }),
                ]);
            } else {
                ventas = await this.fetchVentas(fecha, { keepLoading: true });
            }

            this.setState({
                loading: false,
                detalleVentaLoading: false,
            });

            return { detalle, ventas };
        } catch (e) {
            this.setState({
                loading: false,
                detalleVentaLoading: false,
            });
            return { detalle: null, ventas: null };
        }
    };

    guardarDetalleSolicitud = async (payload) => {
        let shouldRefresh = true;

        try {
            this.setState({ loading: true, detalleVentaLoading: true });

            const resp = await guardarSolicitud(payload);

            if (resp.code === 2003) {
                shouldRefresh = false;
                toast.error("Tu sesión ha expirado");
                this.logoutByTokenExpired();
                return;
            }

            if (resp.code !== 0) {
                toast.info(resp.message || "No fue posible guardar la solicitud");
            } else {
                toast.success(resp.message || "Solicitud guardada correctamente.");
            }
        } catch (e) {
            toast.error("Ocurrió un error al guardar la solicitud");
        } finally {
            if (shouldRefresh) {
                await this.refreshVentasAndDetalle();
            } else {
                this.setState({ loading: false, detalleVentaLoading: false });
            }
        }
    };


    cancelarDetalleSolicitudFactura = async (idsolicitudfactura) => {
        try {
            this.setState({ loading: true, detalleVentaLoading: true });

            const resp = await cancelarFactura(idsolicitudfactura);

            if (resp.code === 2003) {
                toast.error("Tu sesión ha expirado");
                this.logoutByTokenExpired();
                return;
            }

            if (resp.code !== 0) {
                toast.info(resp.message || "No fue posible cancelar la factura");
            } else {
                toast.success(resp.message || "Factura cancelada correctamente.");
            }
        } catch (e) {
            toast.error("Ocurrió un error al cancelar la factura");
        } finally {
            await this.refreshVentasAndDetalle();
        }
    };

    facturarDetalleSolicitud = async () => {
        try {
            this.setState({ loading: true, detalleVentaLoading: true });
            await this.refreshVentasAndDetalle();
        } catch (e) {
            this.setState({ loading: false, detalleVentaLoading: false });
            toast.error("Ocurrió un error al refrescar la información.");
        }
    };

    // ===== icono PDF  =====
    PdfIcon = ({ title = "PDF" }) => (
        <svg className="v-pdf" viewBox="0 0 24 24" aria-label={title} role="img">
            <path d="M6 2h9l5 5v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1v5h5" />
            <path d="M7.5 15.5h2.2c.9 0 1.5-.6 1.5-1.5s-.6-1.5-1.5-1.5H7.5v6m0-3h2.1" />
            <path d="M12.8 18.5v-6h1.9c1.7 0 2.8 1.2 2.8 3s-1.1 3-2.8 3h-1.9z" />
            <path d="M19.2 12.5h2.8m-2.8 3h2.4m-2.4 3h2.1" />
        </svg>
    );

    XmlIcon = ({ title = "XML" }) => (
        <svg className="v-xml" viewBox="0 0 24 24" aria-label={title} role="img">
            <path d="M6 2h9l5 5v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1v5h5" />
            <path d="M7.2 15.2l-2 1.8 2 1.8M16.8 15.2l2 1.8-2 1.8" />
            <path d="M10.5 19l3-8" />
        </svg>
    );

    normalizeText = (v) =>
        String(v ?? "")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

    getFilteredItems = (items) => {
        const q = this.normalizeText(this.state.q).trim();
        if (!q) return items;

        return (items || []).filter((x) => {
            const hay = [
                x?.idticket,
                x?.cliente,
                x?.locacion,
                x?.metodoPago,
                x?.banco,
                x?.afiliacion,
                x?.moneda,
                x?.total,
                x?.importe,
                x?.compania,
                x?.total_cobrado,
                x?.moneda_cobro,
                x?.hora,
                x?.estatus,
            ]
                .map(this.normalizeText)
                .join(" ");

            return hay.includes(q);
        });
    };

    render() {
        const { loading, fecha, vermodalImpor, selectedRowId } = this.state;
        // const items = this.getSortedItems();

        const sorted = this.getSortedItems(); // o tu arreglo original
        const items = this.getFilteredItems(sorted);

        return (
            <div className="v-page">
                <Navbar />

                {loading === true ? <SpinnerModal tipo="full" show={loading} /> : null}

                <ImportVentasModal
                    show={vermodalImpor}
                    banderaSubir={this.state.banderaSubir}
                    toggle={() => this.setState({ vermodalImpor: false })}
                    loading={loading}
                    onImport={this.importVentas}
                    onImportProductos={this.importProductos}
                    onImportSantander={this.importVentasSantnder}
                />

                <VentaDetalleModal
                    show={this.state.showDetalleModal}
                    loading={this.state.detalleVentaLoading}
                    data={this.state.detalleVentaData}
                    array_catalogo_sat={this.state.array_catalogo_sat}
                    array_nacionalidad={this.state.array_nacionalidad}
                    onClose={this.closeDetalleModal}
                    onSave={this.guardarDetalleSolicitud}
                    onCancelarFactura={this.cancelarDetalleSolicitudFactura}
                    onFacturar={this.facturarDetalleSolicitud}
                />

                <VentaEditarModal
                    show={this.state.showEditVenta}
                    loading={this.state.detalleVentaLoading}
                    data={this.state.editVentaData}
                    onClose={this.closeEdit}
                    onSavedLocal={this.handleVentaSavedLocal}
                />


                <div className="v-shell">
                    <div className="v-top">
                        <h1 className="v-title">Ventas</h1>


                        <div className="v-actions">

                            <div className="so-search">
                                <span className="so-ico" aria-hidden="true">🔎</span>

                                <input
                                    type="text"
                                    value={this.state.q}
                                    onChange={(e) => this.setState({ q: e.target.value, selectedRowId: null })}
                                    placeholder="Buscar Venta"
                                    disabled={loading}
                                />

                                {String(this.state.q || "").length > 0 && (
                                    <button
                                        type="button"
                                        className="so-clear"
                                        onClick={() => this.setState({ q: "", selectedRowId: null })}
                                        disabled={loading}
                                        aria-label="Limpiar búsqueda"
                                        title="Limpiar"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>

                            <div className="v-date">
                                <button
                                    type="button"
                                    className="v-btnHoy"
                                    onClick={this.setHoy}
                                    disabled={loading}
                                    title="Fecha actual"
                                >
                                    Hoy
                                </button>

                                <DatePicker
                                    id="ventas-date"
                                    value={this.parseISOToDate(fecha)}
                                    onChange={this.onChangeFecha}
                                    formatStyle="large"
                                    placeholder="Selecciona fecha"
                                />

                                <button
                                    type="button"
                                    className="v-btnRefresh"
                                    onClick={this.refreshVentas}
                                    disabled={loading}
                                >
                                    <FaSyncAlt />
                                </button>
                            </div>


                            <button className="v-btn" onClick={this.onImportar.bind(this, "normal")} disabled={loading}>
                                Importar
                            </button>
                          {/*  <button className="v-btn" onClick={this.onImportar.bind(this, "productos")} disabled={loading}>
                                PRODUCTOS
                            </button>
                            <button className="v-btn" onClick={this.onImportar.bind(this, "santander")} disabled={loading}>
                                SANTANDER
                            </button> */}
                        </div>
                    </div>

                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table">
                                    <thead>
                                        <tr>
                                            <th className="v-thSort" onClick={() => this.onSort("ticket")}>Ticket</th>
                                            <th className="v-thSort" onClick={() => this.onSort("productos")}>Cantidad</th>
                                            <th className="v-thSort" onClick={() => this.onSort("locacion")}>Locación</th>

                                            <th className="v-thSort" onClick={() => this.onSort("metodoPago")}>
                                                Método de pago<br />Últimos dígitos
                                            </th>

                                            <th className="v-thSort" onClick={() => this.onSort("subtotal")}>
                                                Sub Total<br />IVA
                                            </th>

                                            <th className="v-thSort" onClick={() => this.onSort("total")}>Total</th>
                                            <th className="v-thSort" onClick={() => this.onSort("propina")}>Propina</th>

                                            <th className="v-thSort" onClick={() => this.onSort("hora")}>Hora</th>

                                            <th className="v-thSort" onClick={() => this.onSort("afiliacion")}>Afiliación</th>

                                            <th className="v-thSort" onClick={() => this.onSort("banco")}>
                                                Banco<br />Moneda
                                            </th>

                                            <th className="v-thSort" onClick={() => this.onSort("campana")}>Compañía</th>
                                            <th className="v-thSort" onClick={() => this.onSort("cuenta")}>Cuenta</th>

                                            <th className="v-thSort" onClick={() => this.onSort("total")}>
                                                T.C.<br />Total MXN
                                            </th>

                                            <th className="v-thSort" onClick={() => this.onSort("total_cobrado")}>Cobrado</th>

                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>Estatus</th>

                                            <th>Factura</th>
                                            <th>Detalles</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="16" className="v-empty">No hay registros disponibles</td>
                                            </tr>
                                        ) : (
                                            items.map((v) => {
                                                const rowId = v.idticketpago;
                                                const isActive = selectedRowId === rowId;

                                                return (
                                                    <tr
                                                        key={rowId}
                                                        className={`${isActive ? "row-active" : ""} ${this.state.afOpenRowId === rowId ? "row-open" : ""}`}
                                                        onClick={() => this.onSelectRow(rowId)}
                                                        style={{ cursor: "pointer" }}
                                                    >

                                                        <td className="v-mono">{v.idticket}</td>
                                                        <td className="v-num" style={{ textAlign: "right"}}>{v.productos}</td>
                                                        <td>{v.locacion}</td>

                                                        <td>{v.metodo_pago}</td>

                                                        <td className="v-details" style={{ textAlign: "right", whiteSpace: "pre-line" }}>
                                                            {`Sub Total: ${this.currencyMX(v.detalles?.subtotal)}\nIVA: ${this.currencyMX(v.detalles?.iva)}`}
                                                        </td>

                                                        <td className="v-num">{this.currencyMX(v.total)}</td>
                                                        <td className="v-num">{this.currencyMX(v.propina)}</td>

                                                        <td className="v-mono">{v.hora || ""}</td>


                                                        {/* Afiliación (autocomplete) */}
                                                        <td
                                                            className="v-afTd"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            {(() => {
                                                                const rowId = v.idticketpago;
                                                                const query = this.state.afQueryByRow?.[rowId] ?? (v.afiliacion ? `${v.afiliacion} - ${v.banco || ""}` : "");
                                                                const isOpen = this.state.afOpenRowId === rowId;
                                                                const suggestions = this.getAfSuggestions(query);

                                                                return (
                                                                    <div className="v-afAuto">
                                                                        <input
                                                                            className="v-afInput"
                                                                            value={query}
                                                                            onChange={(e) => this.onAfChange(rowId, e.target.value)}
                                                                            onFocus={() => this.setState({ afOpenRowId: rowId })}
                                                                            placeholder="Afiliación - Banco"
                                                                        />

                                                                        {isOpen && suggestions.length > 0 && (
                                                                            <div className="v-afDrop" onClick={(e) => e.stopPropagation()}>
                                                                                {suggestions.map((a) => (
                                                                                    <button
                                                                                        key={a.idafiliacion}
                                                                                        type="button"
                                                                                        className="v-afOpt"
                                                                                        onClick={() => this.onAfSelect(v, a)}
                                                                                        title={`${a.afiliacion} - ${a.banco}`}
                                                                                    >
                                                                                        <div className="v-afOptMain">{this.afLabel(a)}</div>
                                                                                        <div className="v-afOptSub">
                                                                                            {a.compania} • {a.moneda || a.codigo} • {a.cuenta}
                                                                                        </div>
                                                                                    </button>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </td>


                                                        {/* Banco y Moneda (comparten celda) */}
                                                        <td style={{ whiteSpace: "pre-line" }}>
                                                            {`${v.banco || ""}\n${v.moneda || ""}`}
                                                        </td>

                                                        <td>{v.compania || ""}</td>
                                                        <td className="v-mono">{v.cuenta || ""}</td>

                                                        {/* T.C. y Total MXN (comparten celda) */}
                                                        <td style={{ whiteSpace: "pre-line", textAlign: "right" }}>
                                                            {`${v.tc ?? ""}\n${v.totalmxn != null ? this.currencyMX(v.totalmxn) : ""}`}
                                                        </td>



                                                        {/* Cobrado (comparten celda) */}
                                                        <td style={{ whiteSpace: "pre-line", textAlign: "right" }}>
                                                            {`${v.total_cobrado != null ? this.currencyMX(v.total_cobrado) : ""}\n${v.moneda_cobro ?? ""}`}


                                                        </td>





                                                        <td>
                                                            <span className={`v-badge ${this.getEstatusClass(v.idestatus)}`}>
                                                                {v.estatusTxt ?? v.estatus ?? ""}
                                                            </span>
                                                        </td>


                                                        {/* Factura: XML + PDF habilitados solo si facturada */}
                                                        {/* Factura: XML + PDF según estatus */}
                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <div className="v-pdfCol">
                                                                {v.folio !== "" ? (
                                                                    <>
                                                                        <button
                                                                            type="button"
                                                                            className="v-pdfBtn v-pdfBtn--active"
                                                                            title="Descargar XML"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                this.handleDescargarFacturaXml(v);
                                                                            }}
                                                                        >
                                                                            <this.XmlIcon title="Descargar XML" />
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            className="v-pdfBtn v-pdfBtn--active"
                                                                            title="Descargar PDF"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                this.handleDescargarFacturaPdf(v);
                                                                            }}
                                                                        >
                                                                            <this.PdfIcon title="Descargar PDF" />
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <span className="v-pdfDisabled" title="No facturada">
                                                                            <this.XmlIcon title="XML deshabilitado" />
                                                                        </span>

                                                                        <span className="v-pdfDisabled" title="No facturada">
                                                                            <this.PdfIcon title="PDF deshabilitado" />
                                                                        </span>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>


                                                        {/* Detalles: botón */}
                                                        <td className="v-actionsTd" onClick={(e) => e.stopPropagation()}>
    <div className="v-actionsCol">
        <button
            type="button"
            className="v-actionBtn v-actionBtn--view"
            onClick={() => this.verDetalles(v)}
            title="Ver detalle"
        >
            <span className="v-actionIcon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                    <path
                        d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="currentColor"
                        strokeWidth="1.8"
                    />
                </svg>
            </span>
            <span className="v-actionText">Ver</span>
        </button>

        <button
            type="button"
            className="v-actionBtn v-actionBtn--edit"
            onClick={() => this.openEdit(v)}
            disabled={loading}
            title="Editar venta"
        >
            <span className="v-actionIcon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                    <path
                        d="M4 20h4l10.5-10.5a1.8 1.8 0 0 0 0-2.5l-1.5-1.5a1.8 1.8 0 0 0-2.5 0L4 16v4Z"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13.5 6.5l4 4"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
            <span className="v-actionText">Editar</span>
        </button>
    </div>
</td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

